import { Injectable, TemplateRef } from '@angular/core';
import { Validators } from '@angular/forms';
import {
  BaseControl,
  Textbox,
  Custom,
  DateTimePicker,
  Option
} from '@app/shared';


@Injectable()
export class LiquidationDeterminationFormService {

  constructor() { }
  /**
   * Retorna la configuracion del formulario de liquidacion
   *
   * @param {TemplateRef<any>} templeteForm
   * @param {Option[]} options
   * @param {any} data
   * @returns {BaseControl<any>[]}
   * @memberof LiquidationDeterminationFormService
   */
  getForm(templeteForm: TemplateRef<any>, options?: Option[], data?: any): BaseControl<any>[] {
    const controls: BaseControl<any>[] = [
      new Custom({
        order: 1,
        key: 'cboCupon',
        template: templeteForm,
        label: 'Número de cupón:',
        placeholder: 'Seleccione el número de cupón.',
        options: options ? options : [],
        value: data ? data.idcupon ? data.idcupon : null : null,
        validations: {
          validators: [Validators.required]
        },
      }),
      new Textbox({
        order: 2,
        key: 'numValorCancelado',
        type: 'number',
        label: 'Valor cancelado:',
        placeholder: 'Valor cancelado de la consignacion.',
        value: data ? data.valor ? data.valor : null : null,
        disabled: true,
        validations: {
          validators: [Validators.required]
        },
      }),
      new Textbox({
        order: 3,
        key: 'numNumeroRecibo',
        type: 'number',
        label: 'Número de recibo:',
        placeholder: 'Número de recibo de la consignacion.',
        value: data ? data.numero_recibo ? data.numero_recibo : null : null,
        disabled: true,
        validations: {
          validators: [Validators.required]
        },
      }),
      new DateTimePicker({
        order: 4,
        key: 'dtFechaRecibo',
        label: 'Fecha recibo:',
        pickerType: 'calendar',
        value: data ? data.fecha_recibo ? data.fecha_recibo : null : null,
        placeholder: 'Fecha recibo de la consignacion.',
        disabled: true,
      }),
      new Textbox({
        order: 5,
        key: 'txtCodigoConvenio',
        label: 'Código de convenio:',
        placeholder: 'Código de convenio.',
        value: data ? data.codigo_convenio ? data.codigo_convenio : null : null,
        disabled: true,
        validations: {
          validators: [Validators.required]
        },
      }),
    ];
    return controls.sort((a, b) => a.order - b.order);
  }
}



// WEBPACK FOOTER //
// ./src/app/forms/all/liquidation-determination/shared/liquidation-determination.form.service.ts